// Dutch (Nederlands) translations for participant interface
export const nl = {
  // Signup
  signup: {
    welcome: "Welkom bij Kerstquiz!",
    subtitle: "Voer je naam in om deel te nemen aan de quiz",
    namePlaceholder: "Je naam",
    joinButton: "Deelnemen aan quiz",
    joining: "Bezig met deelnemen...",
    sessionCode: "Sessiecode",
    registrationFailed: "Registratie mislukt"
  },

  // Waiting screens
  waiting: {
    welcome: "Welkom",
    welcomeWithName: "Welkom, {name}!",
    waitingForStart: "Wachten tot de quiz start...",
    session: "Sessie",
    participants: "Deelnemers",
    you: "Jij",
    waitingForNext: "Wachten op volgende vraag...",
    waitingForQuestions: "Wachten tot de vragen beginnen..."
  },

  // Questions
  question: {
    question: "Vraag",
    of: "van",
    submitAnswer: "Antwoord indienen",
    answerSubmitted: "Antwoord ingediend ✓",
    typeYourAnswer: "Typ je antwoord...",
    selectTrue: "Waar selecteren",
    selectFalse: "Onwaar selecteren",
    true: "✓ Waar",
    false: "✗ Onwaar",
    option: "Optie {number}",
    answerAlreadySubmitted: "Antwoord al ingediend",
    submitYourAnswer: "Dien je antwoord in",
    questionIllustration: "Vraag illustratie"
  },

  // Answer submitted
  answerSubmitted: {
    title: "Antwoord ingediend!",
    message: "Je antwoord is ontvangen en wordt geëvalueerd.",
    yourAnswer: "Je antwoord:",
    waitingForNext: "Wachten op volgende vraag..."
  },

  // Standings
  standings: {
    title: "Ranglijst",
    leaderboard: "Ranglijst",
    points: "punten",
    pts: "ptn",
    waitingForNext: "Wachten op volgende vraag...",
    finalTitle: "Eindstand",
    finalLeaderboard: "Eindranglijst",
    quizComplete: "🎉 De quiz is afgelopen! Bedankt voor het meedoen! 🎉",
    winner: "Winnaar!"
  },

  // Category intro
  category: {
    waitingForQuestions: "Wachten tot de vragen beginnen..."
  },

  // Lobby
  lobby: {
    title: "Kerstquiz Lobby",
    welcome: "Welkom",
    waitingForStart: "Wachten tot de quiz start...",
    session: "Sessie",
    participants: "Deelnemers"
  },

  // Common
  common: {
    loading: "Laden...",
    error: "Fout",
    retry: "Opnieuw proberen"
  }
};

// Helper function to replace placeholders and get nested values
export const t = (key, params = {}) => {
  const keys = key.split('.');
  let value = nl;
  
  // Navigate through nested object
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }
  
  if (typeof value === 'string') {
    // Replace placeholders like {name} with actual values
    return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey] !== undefined ? params[paramKey] : match;
    });
  }
  
  // If value is not a string, return the key as fallback
  if (value === undefined) {
    console.warn(`Translation key not found: ${key}`);
    return key;
  }
  
  return value;
};

export default nl;

